import apiClient from './base/apiClient'

export interface RankingItem {
  id: string
  placeId: number
  rank: number
  name: string
  address: string
  category: string // 카테고리 코드
  subCategory?: string | null // 서브 카테고리 라벨 (있을 경우만)
  lat?: number | null // 위도
  lng?: number | null // 경도
  rating: number
  zone?: number // 존(0=별로,1=보통,2=좋음) — 순위 재배치 시 존 경계 유지용
  reviewCount?: number
  latestReviewDate?: string
  reviewId?: number // 리뷰 삭제용 (백엔드가 함께 내려줌)
}

export interface GetRankingsResponse {
  rankings: RankingItem[]
  totalCount: number
  categoryCounts?: Record<string, number>
}

export interface UpdateRankingOrderRequest {
  rankings: Array<{
    id: string
    rank: number
    /** 끌어 옮기면서 정해진 존. 없으면 서버가 기존 값을 쓴다 */
    zone?: number
  }>
}

export interface UpdateRankingOrderResponse {
  message: string
}

export const rankingApi = {
  getRankings: async (
    category?: string,
    userId?: string
  ): Promise<GetRankingsResponse> => {
    const params: Record<string, string> = {}
    if (category) params.category = category
    if (userId) params.userId = userId
    const response = await apiClient.get<GetRankingsResponse>('/rankings', {
      params,
    })
    return response.data
  },

  updateOrder: async (
    data: UpdateRankingOrderRequest
  ): Promise<UpdateRankingOrderResponse> => {
    const response = await apiClient.post<UpdateRankingOrderResponse>(
      '/rankings/order',
      {
        rankings: data.rankings,
      }
    )
    return response.data
  },
}
